<template>
    <div class="pagination" v-if="totalPage>1">
        <span :class="['to',current===1?'disabled':'']" @click="changePage(current>1?current-1:1)">上一页</span>
        <span @click="changePage(item)" v-for="item in showPage" :class="current===item?'active':''" :key="item">{{item}}</span>
        <span :class="['to',current===totalPage?'disabled':'']" @click="changePage(current<totalPage?current+1:totalPage)">下一页</span>
    </div>
</template>
<script>
    export default {
        name: 'News',
        props:['totalPage','current','pageNumber'],
        data () {
            return {
                
            }
        },
        computed:{
            showPage(){
                if(this.current>7){
                    if(this.totalPage-this.current>=3){
                        return [this.current-3,this.current-2,this.current-1,this.current,this.current+1,this.current+2,this.current+3]
                    }else{
                        return [this.totalPage-6,this.totalPage-5,this.totalPage-4,this.totalPage-3,this.totalPage-2,this.totalPage-1,this.totalPage]
                    }
                }else{
                    return this.totalPage>7?[1,2,3,4,5,6,7]:this.totalPage
                }
            }
        },
        methods:{
            changePage(index){
                if(index===this.current){
                    return false;
                }
                this.$emit('changePage',index)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .pagination{
        width: 100%;
        text-align: right;
        span{
            display: inline-block;
            width: 52px;
            height: 52px;
            border:1px solid #DCDFE6;
            text-align: center;
            line-height: 52px;
            font-size: 18px;
            cursor: pointer;
            margin: 0 12px;
            &:hover{
                border-color: #1797E0;
                color: #1797E0;
            }
        }
        .active{
            background-color: #1797E0;
            color: #fff;
        }
        .to{
            width: 100px;
        }
        .disabled{
            cursor: not-allowed;
            color: #999;
            &:hover{
                border:1px solid #DCDFE6;
                color: #999;
            }
        }

    }
    @media screen and (max-width: 1200px){
        .pagination{
            span{
                width: 40px;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                margin: 0 6px;
            }
            .to{
                width: 80px;
            }
        }
    }
    @media screen and (max-width: 768px){
        .pagination{
            span{
                width: 26px;
                height: 26px;
                line-height: 26px;
                font-size: 16px;
                margin: 0 1px;
            }
            .to{
                width: 50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue